import { Box, styled } from '@mui/joy';

export const FlexBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 4,
});
